// Bluesky App Pages

export const languageSettingsUrl = 'https://bsky.app/settings/language'
export const privacySecurityUrl =
  'https://bsky.app/settings/privacy-and-security'
export const settingsUrl = 'https://bsky.app/settings'
export const messagesSettingsUrl = 'https://bsky.app/messages/settings'
export const postInteractionSettingsUrl =
  'https://bsky.app/moderation/interaction-settings'

// Bluesky API paths
export const getAuthorFeedPath = '/xrpc/app.bsky.feed.getAuthorFeed'
export const deleteRecordPath = '/xrpc/com.atproto.repo.deleteRecord'
